import comp from "./Table";
export default comp;
